<template>
  <v-card tile>
    <loader v-if="$wait.is('getIzdanjeDetails')" class="pt-12"></loader>
    <v-card-text v-else-if="getOdabranoIzdanje" 
    class="pa-12 pt-0">
      <v-container fluid>
        <v-row no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Naziv izdanja</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="pt-2">
              {{ getOdabranoIzdanje.naziv }}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="getOdabranoIzdanje.izdavaci.length"></v-divider>
        <v-row
          no-gutters
          class="pb-2 pt-2"
          v-if="getOdabranoIzdanje.izdavaci.length"
        >
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Izdavači</h3> </v-col
          ><v-list>
            <v-list-item
              class="mb-n6 mt-n2 ml-n4"
              style="color: black"
              v-for="(izdavaci, i) in getOdabranoIzdanje.izdavaci"
              :key="i"
            >
              <p>
                {{ izdavaci.naziv }}
              </p>
            </v-list-item></v-list
          >
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.baze_izdanja.length"></v-divider>
        <v-row
          no-gutters
          class="pb-2 pt-2"
          v-if="getOdabranoIzdanje.baze_izdanja.length"
        >
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Baze izdanja</h3> </v-col
          ><v-list>
            <v-list-item
              class="mb-n6 mt-n2 ml-n4"
              style="color: black"
              v-for="(baze, i) in getOdabranoIzdanje.baze_izdanja"
              :key="i"
            >
              <p>
                {{ baze.naziv }}
              </p>
            </v-list-item></v-list
          >
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.isbn"></v-divider>
        <v-row no-gutters class="pb-2 pt-2" v-if="getOdabranoIzdanje.isbn">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">ISBN</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span>
              {{ getOdabranoIzdanje.isbn }}
            </span>
            <br />
          </div>
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.issn"></v-divider>
        <v-row no-gutters class="pb-2 pt-2" v-if="getOdabranoIzdanje.issn">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">ISSN</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span>
              {{ getOdabranoIzdanje.issn }}
            </span>
            <br />
          </div>
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.broj"></v-divider>
        <v-row no-gutters class="pb-2 pt-2" v-if="getOdabranoIzdanje.broj">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Broj</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span>
              {{ getOdabranoIzdanje.broj }}
            </span>
            <br />
          </div>
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.mjesto_izdavanja"></v-divider>
        <v-row
          no-gutters
          class="pb-2 pt-2"
          v-if="getOdabranoIzdanje.mjesto_izdavanja"
        >
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Mjesto izdavanja</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span>
              {{ getOdabranoIzdanje.mjesto_izdavanja }}
            </span>
            <br />
          </div>
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.urednik"></v-divider>
        <v-row no-gutters class="pb-2 pt-2" v-if="getOdabranoIzdanje.urednik">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Urednik</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span>
              {{ getOdabranoIzdanje.urednik }}
            </span>
            <br />
          </div>
        </v-row>
        <v-divider v-if="getOdabranoIzdanje.relevantnost != '0'"></v-divider>
        <v-row
          no-gutters
          class="pb-2 pt-2"
          v-if="getOdabranoIzdanje.relevantnost != '0'"
        >
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Relevantnost</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span> Da </span>
            <br />
          </div>
        </v-row>
        <v-divider
          v-if="getOdabranoIzdanje.znanstvena_publikacija != '0'"
        ></v-divider>
        <v-row
          no-gutters
          class="pb-2 pt-2"
          v-if="getOdabranoIzdanje.znanstvena_publikacija != '0'"
        >
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Znanstvena publikacija</h3>
          </v-col>
          <div class="pt-1" style="color: black">
            <span> Da </span>
            <br />
          </div>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  // metaInfo: {
  //   title: 'Detalji o izdanju  - Registar radova'
  // },
  computed: {
    ...mapGetters(["getOdabranoIzdanje", "getTipoviIzdanja"]),
  },
};
</script>